module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18em4Ae/Images/cover.jpg?1685327424946",
      "alt": "This image is the cover for the book Back to the Dream, Dreamlands"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Back to the Dream, Dreamlands\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("Sequel to Dreamlands "), _c('br'), _vm._v("Dreamlands: Book Two")])])]), _c('p', [_vm._v("Although Inuzaka Keno has found freedom and love in the Dreamlands with "), _c('em', [_vm._v("oni")]), _vm._v(" Samojirou Aboshi, the war is still raging between The Trust's battle-hardened recruits and the demons of his new home. While cloaked in shadows and magic, powerful people are using Keno, Aboshi, and their Lord Tamazusa as pawns in a deadly plan to rule both worlds.")]), _vm._v(" "), _c('p', [_vm._v("They're not alone: soldiers Mason, Wolf, and McGann—Keno's friends from The Trust—also find themselves embroiled in the battle spreading through the Dreamlands, involving its other lands and cultures. If they're to have any chance to survive, Aboshi will have to leave his love to protect him, and Keno will have to find the power within himself to live on without his heart.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Felicitas Ivey\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0